/**
 * The type of (redux) action to update the dropbox access token.
 *
 * {
 *     type: UPDATE_DROPBOX_TOKEN,
 *     token: string
 * }
 */
export const UPDATE_DROPBOX_TOKEN = 'UPDATE_DROPBOX_TOKEN';
